/**
 * Alverio theme utilities
 */
(function () {
  function debounce(fn, delay = 250) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(null, args), delay);
    };
  }

  function trapFocus(container) {
    const focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function handleKeydown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', handleKeydown);
    first?.focus();
    return () => container.removeEventListener('keydown', handleKeydown);
  }

  function publish(eventName, detail = {}) {
    document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail }));
  }

  function subscribe(eventName, callback) {
    document.addEventListener(eventName, callback);
    return () => document.removeEventListener(eventName, callback);
  }

  function getCart() {
    return fetch('/cart.js').then((r) => r.json());
  }

  function addToCart(variantId, quantity = 1) {
    return fetch(window.themeSettings.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    }).then((r) => {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    });
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  window.Alverio = {
    debounce,
    trapFocus,
    publish,
    subscribe,
    getCart,
    addToCart,
    prefersReducedMotion,
  };
})();
